// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconFilesFileFileUnknown_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="26.75" cy="26.75" r="5.25" fill="#828D9E"/>
  <circle cx="26.75" cy="26.75" r="5.25" class="svg-fg-stroke"/>
  <path d="M29.5504 24.9687C29.5504 23.6052 28.2834 22.5 26.721 22.5 25.3563 22.5 24.2165 23.3435 23.9502 24.4659L25.5645 24.9687C25.5645 24.4122 26.0837 23.9597 26.7208 23.9597 27.3584 23.9597 27.8771 24.4122 27.8771 24.9687 27.8771 25.3445 27.6399 25.673 27.2896 25.8464 26.7362 26.1279 26.3033 26.5696 26.0708 27.0971 25.9923 27.2769 25.937 27.4661 25.9081 27.663H25.9096V28.1002H27.6193V27.663H27.6162C27.7081 27.4209 27.9024 27.2194 28.1546 27.0971H28.1529C28.9893 26.6686 29.5504 25.876 29.5504 24.9687ZM27.6836 29.0336H25.8169V30.9003H27.6836V29.0336Z" class="svg-fg"/>
  <path d="M5 0H17V2H7V28H19.6074C19.7302 28.7071 19.9556 29.3791 20.2675 30H5V0ZM27 19.5042V10H25V19.7126C25.5604 19.5737 26.1466 19.5 26.75 19.5 26.8337 19.5 26.917 19.5014 27 19.5042ZM19 0 27 8H19V0Z" class="svg-bg"/>
</svg>
`;
/**
 * IconFilesFileFileUnknown is a generated icon component.
 */
let IconFilesFileFileUnknown = IconFilesFileFileUnknown_1 = class IconFilesFileFileUnknown extends IconBaseElement {
    render() {
        return html `${IconFilesFileFileUnknown_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconFilesFileFileUnknown.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconFilesFileFileUnknown = IconFilesFileFileUnknown_1 = __decorate([
    customElement('zui-icon-files-file-file-unknown')
], IconFilesFileFileUnknown);
export { IconFilesFileFileUnknown };
